import { Box } from '@mui/material';
import PaymentOfflineInfromation from './PaymentOfflineInfromation';

const OfflinePaymentInformation = ({
  setPaymentOfflineInformation,
}: {
  setPaymentOfflineInformation: React.Dispatch<React.SetStateAction<null>>;
}) => {
  return (
    <Box>
      <PaymentOfflineInfromation
        setPaymentOfflineInformation={setPaymentOfflineInformation}
      />
    </Box>
  );
};

export default OfflinePaymentInformation;
